/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import AppointmentAction from 'DesignSystem/AppointmentAction/index'
import ConfirmationDialog from './ConfirmationDialog/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/AppointmentActions/DeleteAppointment/Content"
  
}) {
  let flow = fromFlow.useFlow()
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
  return (<React.Fragment
>
<AppointmentAction
  viewPath={`${viewPath}/AppointmentAction`}
 text="Delete appointment"
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, 'ConfirmationDialog/Content'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, 'ConfirmationDialog/Content'))}
/>
<ConfirmationDialog
  viewPath={`${viewPath}/ConfirmationDialog`}
/>
{children}
</React.Fragment>)
}